import { Injectable } from '@angular/core';
import { LpWk8Filter, LpWk8FilterSet, LpWoordData } from '@typings/lp/generated';

@Injectable({
  providedIn: 'root',
})
export class Wk8FilterService {
  applyFilter(words: LpWoordData[], filter: LpWk8Filter): LpWoordData[] {
    const unwrappedWords = words.map((word) => ({
      uid: word.uid,
      labels: word.tags.split(',').map((label) => label.trim()),
      word,
    }));

    // Helper to apply a single FilterSet (including its additionalFilters)
    const applyFilterSet = (filterSet: LpWk8FilterSet): Set<string> => {
      // Parse include/exclude labels
      const includeLabels = filterSet.include
        ? filterSet.include
            .split(',')
            .map((l) => l.trim())
            .filter(Boolean)
        : [];
      const excludeLabels = filterSet.exclude
        ? filterSet.exclude
            .split(',')
            .map((l) => l.trim())
            .filter(Boolean)
        : [];

      // Start with all words
      let matchingUids = new Set(
        unwrappedWords
          .filter(({ labels }) => includeLabels.every((inc) => labels.includes(inc)) && excludeLabels.every((exc) => !labels.includes(exc)))
          .map(({ uid }) => uid),
      );

      // Intersect with results of additionalFilters (if any)
      if (filterSet.additionalFilters && filterSet.additionalFilters.length > 0) {
        for (const additionalFilter of filterSet.additionalFilters) {
          const additionalUids = new Set(this.applyFilter(words, additionalFilter).map((w) => w.uid));
          matchingUids = new Set([...matchingUids].filter((uid) => additionalUids.has(uid)));
        }
      }
      return matchingUids;
    };

    // Union of all FilterSet results
    const resultUids = new Set<string>();
    for (const filterSet of filter.sets) {
      const setUids = applyFilterSet(filterSet);
      setUids.forEach((uid) => resultUids.add(uid));
    }
    // Return the original word objects matching the resultUids
    return words.filter((w) => resultUids.has(w.uid));
  }
}
